var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"btnGolden",attrs:{"size":_vm.size},on:{"click":_vm.btnFavorite_OnClick}},[_c('svg-icon',{attrs:{"iconClass":"favourite"}}),_vm._v(_vm._s(!_vm.isFavorite? '收 藏': '已收藏'))],1)}
var staticRenderFns = []

export { render, staticRenderFns }